import accountApi from '../../api/account/account';
import coachApi from '../../api/coach-profile/coach';

const state = {
  user: {},
  blur: false,
};

// getters
const getters = {
  isAuthorized: (state) => (!!state.user.is_staff || !!state.user.is_coach),
  isAuthenticate: (state) => (!!state.user.uuid),
  isBlur: (state) => (state.blur),
};

// mutations
const mutations = {
  logoutUser(state) {
    state.user = {};
    state.blur = false;
  },

  loginUser(state, data) {
    state.user = data;
  },

  setBlur(state, data) {
    state.blur = data;
  },

  userUpdated(state, data) {
    state.user.first_name = data.first_name;
    state.user.last_name = data.last_name;
    state.user.email = data.email;
    state.user.time_zone = data.time_zone;
  },

  updateProfileImage(state, data) {
    state.user.profile_image = data;
  },
};

// actions
const actions = {
  async getCurrentUser({ commit }) {
    try {
      // empty user data
      commit('logoutUser');

      const response = await coachApi.currentUser();
      // if (!response || !response.is_staff) {
      //   throw new Error('Unauthorized');
      // }
      commit('loginUser', response);
      commit('common/updateShouldRefreshUser', false, { root: true });
      if (typeof response.is_tos_agreed === 'boolean' && !response.is_tos_agreed) {
        commit('setBlur', true);
      }
      return response;
    } catch (err) {
      console.log(err);
      if (err.code && err.code === 403) { commit('setBlur', true); }
      commit('common/updateShouldRefreshUser', false, { root: true });
      return null;
    }
  },

  async logout({ commit }) {
    let data = null;
    try {
      data = await accountApi.logout();
    } catch (err) {
      console.log(err);
    } finally {
      commit('logoutUser');
      commit('common/updateShouldRefreshUser', true, { root: true });
    }
    return data;
  },

  userUpdated({ commit }, data) {
    commit('userUpdated', data);
  },

  updateProfileImage({ commit }, image) {
    commit('updateProfileImage', image);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
